import { limbo10BetStore } from '../limbo10Store/betStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { autoBetStore } from '../../../store/autoBetStore';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { Limbo10SoundsName, MULTIPLIER_LIMIT } from '../limbo10Core/constants';
import { applicationStore } from '../../../store/applicationStore';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { THIS_GAMES_COLUMN_ID } from '../../../core/constants/liveBetsContants';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { isPG } from '../../../core/helpers/skinHelper';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

let autoBetTimeOutId = null;

class Limbo10GameService {
  onGetInitialStateResult({ quickBets, lastSpinInfo, maxWinLimit }) {
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        subSpins: lastSpinInfo.subSpins,
        id: lastSpinInfo.id,
      });
    }
    limbo10BetStore.setMaxWinLimit(maxWinLimit);
    userInfoStore.setLimits({ minBet: quickBets[0], maxBet: quickBets[quickBets.length - 1] });
    applicationStore.setIsConnectionLost(false);
    applicationStore.setIsSocketConnected(true);

    if (isPG()) {
      liveUpdateStore.setSelectedColumn(THIS_GAMES_COLUMN_ID);
    }
    liveUpdateStore.setSelectedColumn(THIS_GAMES_COLUMN_ID);
    limbo10BetStore.handleInitStateBetFields();
  }

  doSpin() {
    const isValid = limbo10BetStore.allLimboBetFields.some(
      (item) =>
        +item.multiplier < MULTIPLIER_LIMIT.minBet || +item.multiplier > MULTIPLIER_LIMIT.maxBet
    );
    if (isValid) {
      return;
    }
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (limbo10BetStore.isBetsClosed) {
      return;
    }
    const model = {
      betOdds: limbo10BetStore.allLimboBetFields,
      isAutoplay: autoBetStore.isAutoBetOn,
    };
    soundService.play(Limbo10SoundsName.bet);
    limbo10BetStore.setIsBetsClosed(true);
    mainGameConnection.doSpin({ spinData: model });
  }

  handleDoSpinResult({ hash, salt, key, newHash, id, responseCode, balance, winAmount, result }) {
    if (responseCode === ValidationType.Success) {
      const { totalResultOdd, subSpins } = result;
      if (isPG()) {
        notificationStore.setNotification(responseCode);
      }
      userInfoStore.setUserBalance(balance);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      limbo10BetStore.setRoundIsWin(null);
      limbo10BetStore.setGameResult(null);
      limbo10BetStore.handleUpdateAllLimboBetFields({
        subSpins,
        key,
        salt,
        hash,
        newHash,
        id,
        allWinAmount: winAmount,
        winOdd: totalResultOdd,
        callBack: () => {
          if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
            autoBetTimeOutId = setTimeout(
              () => {
                this.doSpin();
              },
              userSettingsStore.isTurboOn ? 500 : 1500
            );
          } else {
            this.resetAutoBetState();
          }
        },
      });
    } else {
      notificationStore.setNotification(responseCode);
      limbo10BetStore.setIsBetsClosed(false);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  resetAutoBetState() {
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  clearAutoBetTimeOut() {
    clearTimeout(autoBetTimeOutId);
  }
}

export const limbo10GameService = new Limbo10GameService();
